export const PIN_CATEGORIES = [
    { value: 'trees', label: 'Trees & plants' },
    { value: 'water', label: 'Water & wet ground' },
    { value: 'wildlife', label: 'Wildlife' },
    { value: 'hazard', label: 'Hazard' },
    { value: 'access', label: 'Access' },
    { value: 'work', label: 'Work needed' },
    { value: 'landmark', label: 'Landmark' },
    { value: 'general', label: 'General note' }
];
